// export const BASE_API_URL = "https://localhost:5001";
export const BASE_API_URL = "https://api.verrisapp.com/";

/* user roles */
export const USER_ROLES = {
	MASTER: "master",
	FULL: "full",
	STRUCTURE: "structure",
	CONTENT: "content",
	children: {
		master: ["master", "full", "structure", "content"],
		full: ["full", "structure", "content"],
		structure: ["structure", "content"],
		content: ["content"],
	},
};

/* Regex Strings */

/*eslint no-useless-escape: "off"*/
export const EMAIL = "^([0-9a-zA-Z]+[-._+&])*[0-9a-zA-Z_]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,63}$";
export const MULTI_EMAIL = "^((w+([-+.']w+)*@w+([-.]w+)*.w+([-.]w+)*)(?:[,;]?s*))+$";
export const KEY_NAME = "^[-A-Za-z0-9]{3,50}$";
export const EXPERIENCE_KEY_NAME = "^[-A-Za-z0-9]{3,100}$";
export const APP_NAME = "^[^-+_@&]{2,30}$";
export const MODULE_KEY = "^@[-a-z/]{3,100}$";
export const URL = "^(http(s?)://)[a-zA-Z0-9-.]+\\.[a-zA-Z]{2,}(\\S*)?$";
export const VIDEO_URL = "^(http://|https://)(vimeo.com|youtu.be|www.youtube.com)/([\\w/]+)([?].*)?$";
export const AUDIO_URL = "^(http://|https://)(soundcloud.com)/([\\w/]+)([?].*)?$";
export const BUNDLE_ID = "^([a-z0-9]+.)+([a-z0-9])+$";
// prettier-ignore
export const APPLE_TAGS = "^(\\w+)(,\\s?\\w+)*$";

export const THEME_RGBA_COLOR = "^rgba(d{1,3}s?,d{1,3}s?,d{1,3}s?,d{1}.?d{0,10})$";
export const THEME_BORDER_STYLE = "^(solid|dotted|dashed)$";
export const THEME_NUMERIC_VALUE = "^-?[0-9]{1,10}.?[0-9]{0,10}%?$";
export const MODULE_VERSION = "^d{1,5}.d{1,5}.d{1,5}$";

export const APPETIZE_PUBLIC_KEY = "b_l4rfj6ntjl3wkj2nuvwp6z2vya"; //iOS
export const APPETIZE_PUBLIC_KEY_ANDROID = "cn4je1wavphx5r32g2j3dr202g"; //Android

export const badWords = [
	"4r5e",
	"5h1t",
	"5hit",
	"a55",
	"anal",
	"anus",
	"ar5e",
	"arrse",
	"arse",
	"ass",
	"ass-fucker",
	"asses",
	"assfucker",
	"assfukka",
	"asshole",
	"assholes",
	"asswhole",
	"a_s_s",
	"b!tch",
	"b00bs",
	"b17ch",
	"b1tch",
	"ballbag",
	"ballsack",
	"bastard",
	"beastial",
	"beastiality",
	"bellend",
	"bestial",
	"bestiality",
	"biatch",
	"bitch",
	"bitcher",
	"bitchers",
	"bitches",
	"bitchin",
	"bitching",
	"blow job",
	"blowjob",
	"blowjobs",
	"boiolas",
	"bollock",
	"bollok",
	"boner",
	"boob",
	"boobs",
	"booobs",
	"boooobs",
	"booooobs",
	"booooooobs",
	"buceta",
	"bugger",
	"bum",
	"bunny fucker",
	"butthole",
	"buttmuch",
	"buttplug",
	"c0ck",
	"c0cksucker",
	"carpet muncher",
	"cawk",
	"chink",
	"cipa",
	"cl1t",
	"clit",
	"clitoris",
	"clits",
	"cnut",
	"cock",
	"cock-sucker",
	"cockface",
	"cockhead",
	"cockmunch",
	"cockmuncher",
	"cocks",
	"cocksuck",
	"cocksucked",
	"cocksucker",
	"cocksucking",
	"cocksucks",
	"cocksuka",
	"cocksukka",
	"cok",
	"cokmuncher",
	"coksucka",
	"coon",
	"cum",
	"cummer",
	"cumming",
	"cums",
	"cumshot",
	"cunilingus",
	"cunillingus",
	"cunnilingus",
	"cunt",
	"cuntlick",
	"cuntlicker",
	"cuntlicking",
	"cunts",
	"cyalis",
	"cyberfuc",
	"cyberfuck",
	"cyberfucked",
	"cyberfucker",
	"cyberfuckers",
	"cyberfucking",
	"d1ck",
	"damn",
	"dick",
	"dickhead",
	"dildo",
	"dildos",
	"dink",
	"dinks",
	"dirsa",
	"dlck",
	"dog-fucker",
	"doggin",
	"dogging",
	"donkeyribber",
	"doosh",
	"duche",
	"dyke",
	"ejaculate",
	"ejaculated",
	"ejaculates",
	"ejaculating",
	"ejaculatings",
	"ejaculation",
	"ejakulate",
	"f u c k",
	"f u c k e r",
	"f4nny",
	"fag",
	"fagging",
	"faggitt",
	"faggot",
	"faggs",
	"fagot",
	"fagots",
	"fags",
	"fanny",
	"fannyflaps",
	"fannyfucker",
	"fanyy",
	"fatass",
	"fcuk",
	"fcuker",
	"fcuking",
	"feck",
	"fecker",
	"felching",
	"fellate",
	"fellatio",
	"fingerfuck",
	"fingerfucked",
	"fingerfucker",
	"fingerfuckers",
	"fingerfucking",
	"fingerfucks",
	"fistfuck",
	"fistfucked",
	"fistfucker",
	"fistfuckers",
	"fistfucking",
	"fistfuckings",
	"fistfucks",
	"flange",
	"fook",
	"fooker",
	"fuck",
	"fucka",
	"fucked",
	"fucker",
	"fuckers",
	"fuckhead",
	"fuckheads",
	"fuckin",
	"fucking",
	"fuckings",
	"fuckingshitmotherfucker",
	"fuckme",
	"fucks",
	"fuckwhit",
	"fuckwit",
	"fudge packer",
	"fudgepacker",
	"fuk",
	"fuker",
	"fukker",
	"fukkin",
	"fuks",
	"fukwhit",
	"fukwit",
	"fux",
	"fux0r",
	"f_u_c_k",
	"gangbang",
	"gangbanged",
	"gangbangs",
	"gaylord",
	"gaysex",
	"goatse",
	"god-dam",
	"god-damned",
	"goddamn",
	"goddamned",
	"hardcoresex",
	"heshe",
	"hoar",
	"hoare",
	"hoer",
	"homo",
	"hore",
	"horniest",
	"horny",
	"hotsex",
	"jack-off",
	"jackoff",
	"jerk-off",
	"jism",
	"jiz",
	"jizm",
	"jizz",
	"kawk",
	"knobead",
	"knobed",
	"knobend",
	"knobhead",
	"knobjocky",
	"knobjokey",
	"kock",
	"kondum",
	"kondums",
	"kum",
	"kummer",
	"kumming",
	"kums",
	"kunilingus",
	"l3itch",
	"labia",
	"lmfao",
	"m0f0",
	"m0fo",
	"m45terbate",
	"ma5terb8",
	"ma5terbate",
	"masochist",
	"mo-fo",
	"mof0",
	"mofo",
	"mothafuck",
	"mothafucka",
	"mothafuckas",
	"mothafuckaz",
	"mothafucked",
	"mothafucker",
	"mothafuckers",
	"mothafuckin",
	"mothafucking",
	"mothafuckings",
	"mothafucks",
	"mother fucker",
	"motherfuck",
	"motherfucked",
	"motherfucker",
	"motherfuckers",
	"motherfuckin",
	"motherfucking",
	"motherfuckings",
	"motherfuckka",
	"motherfucks",
	"mutha",
	"muthafecker",
	"muthafuckker",
	"muther",
	"mutherfucker",
	"n1gga",
	"n1gger",
	"nazi",
	"nigg3r",
	"nigg4h",
	"nigga",
	"niggah",
	"niggas",
	"niggaz",
	"nigger",
	"niggers",
	"nob jokey",
	"nobhead",
	"nobjocky",
	"nobjokey",
	"numbnuts",
	"nutsack",
	"orgasim",
	"orgasims",
	"orgasm",
	"orgasms",
	"p0rn",
	"pawn",
	"pecker",
	"penis",
	"penisfucker",
	"phonesex",
	"phuck",
	"phuk",
	"phuked",
	"phuking",
	"phukked",
	"phukking",
	"phuks",
	"phuq",
	"pigfucker",
	"pimpis",
	"piss",
	"pissed",
	"pisser",
	"pissers",
	"pisses",
	"pissflaps",
	"pissin",
	"pissing",
	"pissoff",
	"poop",
	"porn",
	"porno",
	"pornos",
	"prick",
	"pricks",
	"pron",
	"pube",
	"pusse",
	"pussi",
	"pussies",
	"pussy",
	"pussys",
	"rectum",
	"retard",
	"rimjaw",
	"rimming",
	"s hit",
	"s.o.b.",
	"sadist",
	"schlong",
	"screwing",
	"scroat",
	"scrote",
	"semen",
	"sh!t",
	"sh1t",
	"shag",
	"shagger",
	"shaggin",
	"shagging",
	"shemale",
	"shit",
	"shitdick",
	"shite",
	"shited",
	"shitey",
	"shitfuck",
	"shitfull",
	"shithead",
	"shithole",
	"shiting",
	"shitings",
	"shits",
	"shitted",
	"shitter",
	"shitters",
	"shitting",
	"shittings",
	"shitty",
	"skank",
	"slut",
	"sluts",
	"smegma",
	"smut",
	"son-of-a-bitch",
	"spac",
	"spunk",
	"s_h_i_t",
	"t1tt1e5",
	"t1tties",
	"teets",
	"teez",
	"testical",
	"testicle",
	"tit",
	"titfuck",
	"tits",
	"titt",
	"tittie5",
	"tittiefucker",
	"titties",
	"tittyfuck",
	"tittywank",
	"titwank",
	"turd",
	"tw4t",
	"twat",
	"twathead",
	"twatty",
	"twunt",
	"twunter",
	"v14gra",
	"v1gra",
	"vagina",
	"viagra",
	"vulva",
	"wang",
	"wank",
	"wanker",
	"wanky",
	"whoar",
	"whore",
];
